import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';          
import { store } from './app/store';    
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css'; 
import "@fontsource/source-sans-3";  
import "@fontsource/barlow-semi-condensed/300.css";    
import "@fontsource/montserrat/700.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/bodoni-moda/400.css"; 
import '@fontsource/inter/400.css';  
import "@fontsource/libre-baskerville/400.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/300.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>                       
    <Provider store={store}>                    
       <App/>
    </Provider>
</React.StrictMode>
);
